// extracted by mini-css-extract-plugin
export default {"tableContainer":"scalegroup_tableContainer__dFGrP","titleCell":"scalegroup_titleCell__378cS","selected":"scalegroup_selected__QflYW"};